import type { TutorSessionType } from './Tutor';
import type { PassEligibleTutor, PassOfferSummary } from './Pass';

/**
 * Host-catalog lesson option status.
 * REMOVED is backend-only soft-delete and must never be exposed in the FE
 * (list/detail omit it; remove action treats the option as gone).
 */
export type LessonOptionStatus = 'ACTIVE' | 'INACTIVE' | 'ARCHIVED';

export type LessonOptionSessionType = TutorSessionType;

export const LESSON_OPTION_DURATION_MINUTES = [30, 45, 60, 90, 120] as const;

export type LessonOptionDurationMinutes = (typeof LESSON_OPTION_DURATION_MINUTES)[number];

export interface LessonOptionUpsertRequest {
  name: string;
  description?: string | null;
  durationMinutes: LessonOptionDurationMinutes;
  price: number;
  currencyCode?: string | null;
  sessionType: LessonOptionSessionType;
}

export interface LessonOptionSummaryResponse {
  id: string;
  organizationId: string;
  name: string;
  description?: string | null;
  durationMinutes: number;
  price: number;
  currencyCode: string;
  sessionType: LessonOptionSessionType;
  status: LessonOptionStatus;
  assignedTutorCount: number;
}

export interface LessonOptionDetailResponse extends LessonOptionSummaryResponse {
  createdAt: string;
  updatedAt: string;
  assignedTutorIds: string[];
  /** Assigned tutors with identity for the host lesson view. Empty array when none. */
  assignedTutors?: PassEligibleTutor[];
  /** Current (ACTIVE + INACTIVE) pass offers attached to this lesson. Empty array when none. */
  relatedPasses?: PassOfferSummary[];
}
